import { useEffect, useState } from 'react';
import { gtag } from 'ga-gtag';

export const useApplyBESessionId = () => {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    let cancelled = false;
    const handleSessionId = () => {
      gtag('get', 'G-0EPPRY67GD', 'session_id', (id) => {
        if (!cancelled) {
          setSessionId(id || '');
        }
      });
    };

    handleSessionId();
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    DLSessionId: sessionId,
  };
};
